angular
  .module 'filters'
  .filter 'waiverType', ($filter) ->
    (type) ->
      if type is 'non_attending_contact'
        'Not attending'
      else
        $filter('humanize')(type)
